import React from "react";
import "./myPatientsViewTableCell.scss";
import AppointmentsViewTableCell from "../../../common/AppointmentsViewTableCell";

const MyPatientsViewTableCell = (props) => {
  const { appointmentsData } = props;

  // Display UI ===>

  const displayMyPatientsViewTableCell = () => {
    return (
      <div className="mypatients-view-table-cell">
        <AppointmentsViewTableCell
          dashboardAppointmentsData={appointmentsData}
          myPatients={true}
          {...props}
        />
      </div>
    );
  };

  // <===

  return <>{displayMyPatientsViewTableCell()}</>;
};

export default MyPatientsViewTableCell;
